import React from 'react';

export default function PanelLeyenda({ hasRenabapData = false, hasRppvapData = false, hasRenabapTargets = false, hasRppvapTargets = false, showBeneficiario = false, showAsignandoPunto = false }) {
  return (
    <div className="absolute bottom-2 left-2 bg-white bg-opacity-95 rounded-lg shadow-lg p-3 z-10">
      <h3 className="text-xs font-semibold text-gray-500 uppercase mb-2">Leyenda</h3>
      <div className="space-y-1 text-xs text-gray-700">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-sm shrink-0" style={{ backgroundColor: 'rgba(255,0,0,0.2)' }} />
          <span>Límite Partido</span>
        </div>
        {hasRenabapData && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-sm shrink-0" style={{ backgroundColor: 'rgba(33,150,243,0.2)' }} />
            <span>Barrios RENABAP</span>
          </div>
        )}
        {hasRppvapData && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-sm shrink-0" style={{ backgroundColor: 'rgba(76,175,80,0.2)' }} />
            <span>Barrios RPPVAP</span>
          </div>
        )}
        {hasRenabapTargets && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-sm shrink-0" style={{ backgroundColor: 'rgba(33,150,243,0.2)', border: '1px solid #2196F3' }} />
            <span>RENABAP seleccionado</span>
          </div>
        )}
        {hasRppvapTargets && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-sm shrink-0" style={{ backgroundColor: 'rgba(76,175,80,0.2)', border: '1px solid #4CAF50' }} />
            <span>RPPVAP seleccionado</span>
          </div>
        )}
        {showBeneficiario && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: '#2196F3' }} />
            <span>Beneficiario</span>
          </div>
        )}
        {showAsignandoPunto && (
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: '#e74c3c' }} />
            <span className="text-gray-400">Asignando punto...</span>
          </div>
        )}
      </div>
    </div>
  );
}
